import { Alert, AlertDescription, AlertIcon, Box, IconButton, VStack, useToast } from '@chakra-ui/react';
import { useWSysPage } from "@coimbra-its/websys-ux-core";
import CopyToClipboard from "react-copy-to-clipboard";
import { APPICONS } from '../Icons';
import { SunBlock, SunPage, SunStack, SunValue, dispAddress, formatAmount } from "../components/Sun";
import { SunState, useSunStore } from '../store/sunSlice';
import { formatUnits } from 'ethers';

export function Wallet() {
    const page = useWSysPage({ title: 'Wallet', maxCols: 2 });

    const connectedWallet = useSunStore((state: SunState) => state.connectedWallet);
    const walletError = useSunStore((state: SunState) => state.walletError);
    const amounts = useSunStore((state: SunState) => state.walletAmounts);
    const toast = useToast();




    return <SunPage page={page}>

        <SunStack>
            {walletError && <Alert status='error'>
                <AlertIcon /><AlertDescription>{walletError}</AlertDescription>
            </Alert>}
            {connectedWallet && <>

                <SunBlock header='Wallet Address'>
                    <Box flex='1'> {dispAddress(connectedWallet.address)}</Box>
                    <CopyToClipboard text={connectedWallet.address} onCopy={() => { toast({ description: 'Address copied to clipboard' }) }} >
                        <IconButton aria-label='copy to clipboard' icon={<APPICONS.Copy />} variant='link' color='orange' />
                    </CopyToClipboard>
                </SunBlock>

                <SunBlock header='SDNB3 Token Balance'>
                    <SunValue dim='SDBN3'>{formatAmount(amounts.TokenBalance)}</SunValue>
                </SunBlock>

                <SunBlock header='SDNB3+ Token Balance'>
                    <SunValue dim='SDBN3+'>{formatAmount(amounts.Token2PlusBalance)}</SunValue>
                </SunBlock>

                <SunBlock header='USDT Balance'>
                    <SunValue dim='USDT'>{formatAmount(amounts.USDTBalance)}</SunValue>
                </SunBlock>

                <SunBlock header='BNB Balance'>
                    <SunValue dim='BNB'>{formatAmount(amounts.BNBBalance)}</SunValue>
                </SunBlock>

            </>}

        </SunStack>

    </SunPage>
}